import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ReadMore = () => {
    const { serviceId } = useParams();
    const navigate = useNavigate();

    // Mock data for services - in real app, this would come from an API
    const servicesData = {
        'online-degrees': {
            title: 'اختبارات إلكترونية',
            description: 'نقدم مجموعة متكاملة من الاختبارات الإلكترونية المصممة خصيصاً لتقييم مستوى الطلاب وتحديد نقاط القوة والضعف لديهم. تتميز اختباراتنا بالدقة والموثوقية وتغطي جميع المناهج الدراسية.',
            features: [
                'اختبارات تفاعلية ومباشرة',
                'تقييم فوري للنتائج',
                'تقارير تحليلية مفصلة',
                'متابعة تقدم الطلاب',
                'أسئلة متنوعة ومتدرجة'
            ],
            image: '/assets/images/service-01.png',
            stats: [
                { value: '500+', label: 'اختبار متاح' },
                { value: '10K+', label: 'طالب نشط' },
                { value: '95%', label: 'دقة التقييم' }
            ],
            testimonials: [
                {
                    name: 'أحمد محمد',
                    role: 'طالب',
                    text: 'الاختبارات الإلكترونية ساعدتني كثيراً في تحسين مستواي الدراسي وتحديد نقاط الضعف التي أحتاج للتركيز عليها.',
                    avatar: '/assets/images/avatar-01.jpg'
                },
                {
                    name: 'سارة أحمد',
                    role: 'معلمة',
                    text: 'منصة رائعة تساعدني في تقييم مستوى طلابي بشكل دقيق وتوفير تقارير مفصلة عن أدائهم.',
                    avatar: '/assets/images/avatar-02.jpg'
                }
            ],
            benefits: [
                {
                    icon: 'fas fa-clock',
                    title: 'توفير الوقت',
                    description: 'اختبارات سريعة وفعالة مع نتائج فورية'
                },
                {
                    icon: 'fas fa-chart-line',
                    title: 'تحليل متقدم',
                    description: 'تقارير تحليلية مفصلة تساعد في تحسين الأداء'
                },
                {
                    icon: 'fas fa-mobile-alt',
                    title: 'سهولة الوصول',
                    description: 'يمكن الوصول للاختبارات من أي جهاز وفي أي وقت'
                }
            ]
        },
        'short-courses': {
            title: 'دورات تعليمية',
            description: 'نقدم مجموعة متنوعة من الدورات التعليمية المتميزة التي تساعد الطلاب على تطوير مهاراتهم وتحسين مستواهم الأكاديمي. يتم تقديم الدورات من قبل نخبة من المعلمين المتخصصين.',
            features: [
                'دورات مكثفة وفعالة',
                'محتوى تعليمي عالي الجودة',
                'دعم مباشر من المعلمين',
                'تمارين وتطبيقات عملية',
                'شهادات معتمدة'
            ],
            image: '/assets/images/service-02.png',
            stats: [
                { value: '100+', label: 'دورة متاحة' },
                { value: '50+', label: 'معلم محترف' },
                { value: '98%', label: 'رضا الطلاب' }
            ],
            testimonials: [
                {
                    name: 'محمد علي',
                    role: 'طالب',
                    text: 'الدورات التعليمية ساعدتني في فهم المواد الدراسية بشكل أفضل وتحسين درجاتي.',
                    avatar: '/assets/images/avatar-03.jpg'
                },
                {
                    name: 'فاطمة حسن',
                    role: 'طالبة',
                    text: 'المحتوى التعليمي مميز جداً والمعلمون متعاونون دائماً في تقديم المساعدة.',
                    avatar: '/assets/images/avatar-04.jpg'
                }
            ],
            benefits: [
                {
                    icon: 'fas fa-graduation-cap',
                    title: 'تعليم متميز',
                    description: 'مناهج دراسية معتمدة ومحتوى تعليمي عالي الجودة'
                },
                {
                    icon: 'fas fa-users',
                    title: 'مجتمع تعليمي',
                    description: 'تفاعل مع زملاء الدراسة والمعلمين في بيئة تعليمية متكاملة'
                },
                {
                    icon: 'fas fa-certificate',
                    title: 'شهادات معتمدة',
                    description: 'شهادات معتمدة معترف بها في المؤسسات التعليمية'
                }
            ]
        },
        'web-experts': {
            title: 'تقييم الطلاب',
            description: 'نقدم نظام متكامل لتقييم أداء الطلاب ومتابعة تقدمهم الأكاديمي. يمكن للمعلمين من خلال هذا النظام تقديم تقييمات دقيقة ومفصلة تساعد في تحسين مستوى الطلاب.',
            features: [
                'تقييم شامل ومتكامل',
                'تقارير دورية مفصلة',
                'متابعة مستمرة للتقدم',
                'توصيات شخصية',
                'تحليل إحصائي للأداء'
            ],
            image: '/assets/images/service-03.png',
            stats: [
                { value: '1000+', label: 'تقرير شهري' },
                { value: '200+', label: 'مدرسة مشاركة' },
                { value: '99%', label: 'دقة التقييم' }
            ],
            testimonials: [
                {
                    name: 'خالد عبدالله',
                    role: 'مدير مدرسة',
                    text: 'نظام التقييم ساعدنا في تحسين مستوى طلابنا بشكل ملحوظ من خلال المتابعة المستمرة والتقارير المفصلة.',
                    avatar: '/assets/images/avatar-05.jpg'
                },
                {
                    name: 'نورا محمود',
                    role: 'معلمة',
                    text: 'أداة مميزة تساعدني في متابعة تقدم طلابي وتقديم التغذية الراجعة المناسبة لهم.',
                    avatar: '/assets/images/avatar-06.jpg'
                }
            ],
            benefits: [
                {
                    icon: 'fas fa-chart-bar',
                    title: 'تحليل متقدم',
                    description: 'تقارير إحصائية مفصلة عن أداء الطلاب'
                },
                {
                    icon: 'fas fa-tasks',
                    title: 'متابعة مستمرة',
                    description: 'تتبع تقدم الطلاب وتحديد نقاط التحسين'
                },
                {
                    icon: 'fas fa-comments',
                    title: 'تواصل فعال',
                    description: 'قنوات تواصل مباشرة بين المعلمين والطلاب'
                }
            ]
        }
    };

    const service = servicesData[serviceId];

    if (!service) {
        return (
            <div className="not-found-container">
                <div className="not-found-content">
                    <h1>404</h1>
                    <p>الخدمة غير موجودة</p>
                    <button className="back-home-btn" onClick={() => navigate('/')}>
                        العودة للرئيسية
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="read-more-section">
            <div className="read-more-container">
                <button className="back-btn" onClick={() => navigate('/')}>
                    <i className="fas fa-arrow-right"></i>
                </button>
                
                <div className="service-header">
                    <div className="service-image">
                        <img src={service.image} alt={service.title} />
                    </div>
                    <div className="service-title">
                        <h1>{service.title}</h1>
                    </div>
                </div>

                <div className="service-stats">
                    {service.stats.map((stat, index) => (
                        <div key={index} className="stat-card">
                            <div className="stat-value">{stat.value}</div>
                            <div className="stat-label">{stat.label}</div>
                        </div>
                    ))}
                </div>

                <div className="service-content">
                    <div className="service-description">
                        <h2>نبذة عن الخدمة</h2>
                        <p>{service.description}</p>
                    </div>

                    <div className="service-features">
                        <h2>مميزات الخدمة</h2>
                        <ul>
                            {service.features.map((feature, index) => (
                                <li key={index}>
                                    <i className="fas fa-check-circle"></i>
                                    {feature}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="service-benefits">
                    <h2>فوائد الخدمة</h2>
                    <div className="benefits-grid">
                        {service.benefits.map((benefit, index) => (
                            <div key={index} className="benefit-card">
                                <i className={benefit.icon}></i>
                                <h3>{benefit.title}</h3>
                                <p>{benefit.description}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="service-testimonials">
                    <h2>آراء المستخدمين</h2>
                    <div className="testimonials-grid">
                        {service.testimonials.map((testimonial, index) => (
                            <div key={index} className="testimonial-card">
                                <div className="testimonial-header">
                                    <img src={testimonial.avatar} alt={testimonial.name} className="testimonial-avatar" />
                                    <div className="testimonial-info">
                                        <h3>{testimonial.name}</h3>
                                        <span>{testimonial.role}</span>
                                    </div>
                                </div>
                                <p>{testimonial.text}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="service-cta">
                    <h2>ابدأ الآن</h2>
                    <p>انضم إلينا اليوم واستفد من خدماتنا المتميزة</p>
                    <button className="cta-button" onClick={() => navigate('/register')}>
                        سجل الآن
                        <i className="fas fa-arrow-left"></i>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReadMore; 